import React from 'react';
import { useAppSelector } from '@store/hooks';

import BalanceDetailsControl from '@components/balance-details/balance-details';

import { IUserSession } from '@entities/user-session';

import { serverFetch } from '@flc/server';

const BalanceDetails = () => {
    const userSession = useAppSelector<IUserSession>((s) => s.userSession);

    return (
        <BalanceDetailsControl
            userId={userSession.userId}
            isViewMode={true}
            showExchangeRateInfo={false}
            useTagRequired={userSession.useTagRequired}
            tag={userSession.tag}
            serverFetch={serverFetch}
        />
    );
};

export default BalanceDetails;
